export default __webpack_public_path__ + "7d55f698e82cef51e189a15d416c6da3.png";